module.exports = __webpack_public_path__ + "static/media/select_item.1a4bd924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/select_item.png
// module id = 651
// module chunks = 0